export const ARTICLES = [
  {
    slug: "licenziamento-cosa-fare-termini-impugnazione",
    title: "Licenziamento: cosa fare e quali sono i termini per impugnarlo",
    category: "Diritto del lavoro",
    date: "2026-06-18",
    dateLabel: "18 giugno 2026",
    readingTime: "4 min",
    excerpt:
      "I termini per contestare un licenziamento sono brevi e perentori. Ecco cosa fare subito, quali documenti raccogliere e quali tutele esistono.",
    metaDescription:
      "Licenziamento ricevuto: i termini di 60 e 180 giorni per l'impugnazione, le tutele possibili e cosa fare subito. Guida dell'Avv. Manfredi Bruno, Palermo.",
    blocks: [
      {
        type: "p",
        text: "Ricevere una lettera di licenziamento è un evento che può generare incertezza e preoccupazione. La prima cosa da sapere è che la legge concede al lavoratore la possibilità di contestare il provvedimento, ma entro termini brevi e perentori. Comprenderli subito fa la differenza tra potersi difendere e perdere ogni tutela.",
      },
      { type: "h2", text: "I termini per impugnare il licenziamento" },
      {
        type: "p",
        text: "Il licenziamento deve essere impugnato in via stragiudiziale entro 60 giorni dalla comunicazione. L'impugnazione può avvenire con una lettera dell'avvocato o con il deposito del tentativo di conciliazione presso la sede competente. Decorso questo termine senza impugnazione, il licenziamento diventa definitivo e non è più contestabile.",
      },
      {
        type: "p",
        text: "Dopo l'impugnazione stragiudiziale, il ricorso al giudice deve essere depositato entro 180 giorni. Anche questo termine è perentorio: per questo, anche quando si spera in una soluzione bonaria, è essenziale che i passaggi formali siano compiuti nei tempi corretti.",
      },
      { type: "h2", text: "Quali tutele sono possibili" },
      {
        type: "p",
        text: "Le conseguenze di un licenziamento illegittimo dipendono dal tipo di licenziamento, dal vizio riscontrato e dalla data di assunzione. Alcune ipotesi di licenziamento sono considerate nulle dalla legge — ad esempio quello discriminatorio, quello intimato in forma orale o in violazione di specifici divieti — e comportano la tutela più forte, compresa la possibilità di reintegrazione. In altri casi la tutela è indennitaria: il lavoratore ha diritto a un risarcimento commisurato all'anzianità e ad altri parametri.",
      },
      {
        type: "p",
        text: "Va detto con chiarezza che non esiste un esito scontato: ogni caso richiede la valutazione dei documenti, del motivo addotto dal datore di lavoro e del comportamento tenuto dalle parti. Una stima realistica delle possibilità è il primo risultato di una consulenza seria.",
      },
      { type: "h2", text: "Cosa fare subito" },
      {
        type: "list",
        items: [
          "Conserva la lettera di licenziamento e la busta in cui è arrivata",
          "Non firmare dimissioni volontarie o accordi senza una valutazione preventiva",
          "Raccogli contratto di lavoro, ultime buste paga e ogni comunicazione rilevante",
          "Annota date, fatti e circostanze mentre sono ancora chiari nella memoria",
          "Contatta tempestivamente un avvocato per verificare i termini del tuo caso",
        ],
      },
      { type: "h2", text: "Perché la tempestività è decisiva" },
      {
        type: "p",
        text: "Sessanta giorni possono sembrare molti, ma tra la ricerca dei documenti, la valutazione e la preparazione dell'impugnazione il tempo passa in fretta. Se hai ricevuto un licenziamento a Palermo o in provincia, puoi richiedere un appuntamento presso il mio studio per una prima valutazione della tua situazione e delle possibili forme di tutela.",
      },
    ],
  },
  {
    slug: "tfr-non-pagato-cosa-fare",
    title: "TFR non pagato: cosa può fare il lavoratore",
    category: "Diritto del lavoro",
    date: "2026-06-04",
    dateLabel: "4 giugno 2026",
    readingTime: "4 min",
    excerpt:
      "Il trattamento di fine rapporto spetta sempre alla cessazione del rapporto di lavoro. Se il datore non paga, esistono strumenti concreti, compreso il Fondo di garanzia INPS.",
    metaDescription:
      "TFR non pagato dal datore di lavoro: prescrizione, diffida, decreto ingiuntivo e Fondo di garanzia INPS in caso di insolvenza. Guida pratica.",
    blocks: [
      {
        type: "p",
        text: "Il trattamento di fine rapporto (TFR) è una somma che matura mese dopo mese durante il rapporto di lavoro e che spetta al lavoratore in ogni caso di cessazione: licenziamento, dimissioni o pensionamento. Quando il datore di lavoro non lo corrisponde, il lavoratore non è senza difese.",
      },
      { type: "h2", text: "Quando spetta il TFR e come si calcola" },
      {
        type: "p",
        text: "Il TFR si accantona annualmente in misura proporzionale alla retribuzione e viene erogato alla fine del rapporto, qualunque ne sia la causa. Il calcolo tiene conto delle retribuzioni percepite e della rivalutazione annuale delle quote accantonate. In caso di contestazione sull'importo, è utile confrontare la liquidazione ricevuta con le buste paga e con il contratto collettivo applicabile.",
      },
      { type: "h2", text: "Attenzione alla prescrizione" },
      {
        type: "p",
        text: "Il diritto al TFR è soggetto a prescrizione: trascorso il termine previsto dalla legge, la somma non può più essere reclamata. Anche le singole voci retributive non pagate si prescrivono in genere in cinque anni. Una richiesta scritta formalmente corretta interrompe il decorso della prescrizione: un motivo in più per non rimandare.",
      },
      { type: "h2", text: "Gli strumenti per recuperare le somme" },
      {
        type: "list",
        items: [
          "Diffida formale al datore di lavoro, con richiesta di pagamento entro un termine",
          "Tentativo di conciliazione presso la sede sindacale o la Direzione territoriale del lavoro",
          "Ricorso per decreto ingiuntivo: procedimento rapido quando il credito è documentato",
          "Causa ordinaria davanti al giudice del lavoro, nei casi più complessi",
          "Esecuzione forzata sui beni del datore, una volta ottenuto il titolo",
        ],
      },
      {
        type: "p",
        text: "La scelta dello strumento dipende dalla situazione concreta: entità del credito, documentazione disponibile, condizioni economiche dell'azienda. In molti casi una diffida ben costruita è sufficiente a sbloccare la posizione.",
      },
      { type: "h2", text: "Se l'azienda è insolvente: il Fondo di garanzia INPS" },
      {
        type: "p",
        text: "Quando il datore di lavoro è sottoposto a procedura concorsuale o è comunque insolvente, interviene il Fondo di garanzia INPS, che può corrispondere al lavoratore il TFR e le retribuzioni degli ultimi tre mesi del rapporto. La domanda richiede requisiti e documentazione specifici, e anche i tempi dell'istituto vanno gestiti con attenzione. Se ti trovi in questa situazione a Palermo o in provincia, posso assisterti nella verifica dei presupposti e nella presentazione della richiesta.",
      },
    ],
  },
  {
    slug: "ricorso-inps-quando-come-funziona",
    title: "Ricorso contro l'INPS: quando è possibile e come funziona",
    category: "Diritto previdenziale",
    date: "2026-05-21",
    dateLabel: "21 maggio 2026",
    readingTime: "5 min",
    excerpt:
      "Una domanda respinta o una richiesta di restituzione non sono necessariamente definitive. Come leggere il provvedimento e quali strumenti di tutela esistono.",
    metaDescription:
      "Ricorso contro l'INPS: quando è possibile, differenza tra ricorso amministrativo e giudiziario, termini e documenti utili. Guida dell'Avv. Manfredi Bruno.",
    blocks: [
      {
        type: "p",
        text: "L'INPS gestisce prestazioni che toccano momenti essenziali della vita: pensione, invalidità, sostegni al reddito. Quando arriva un provvedimento sfavorevole — un rigetto, una revoca, una richiesta di restituzione — è naturale sentirsi spiazzati. Ma un provvedimento sfavorevole non è necessariamente definitivo.",
      },
      { type: "h2", text: "Quando è possibile il ricorso" },
      {
        type: "list",
        items: [
          "La domanda di pensione o di altra prestazione è stata respinta",
          "Una prestazione già concessa è stata revocata",
          "L'assegno è stato calcolato in modo errato o con contributi mancanti",
          "L'INPS chiede indietro somme già percepite (recupero di indebito)",
          "Periodi di lavoro non risultano accreditati nella posizione contributiva",
        ],
      },
      { type: "h2", text: "Prima di tutto: leggere il provvedimento" },
      {
        type: "p",
        text: "Il provvedimento INPS indica le ragioni del rigetto o della richiesta e, di regola, i termini e le modalità per contestarlo. Da queste informazioni dipende la strategia: per alcune materie è previsto un ricorso amministrativo ai comitati interni dell'istituto, per altre è necessario rivolgersi direttamente al giudice del lavoro. I termini sono spesso brevi e decorrono dalla comunicazione: conservare la lettera e la data di ricevimento è essenziale.",
      },
      { type: "h2", text: "Ricorso amministrativo o giudiziario" },
      {
        type: "p",
        text: "Il ricorso amministrativo consente di chiedere all'INPS un riesame della pratica; il ricorso giudiziario porta la questione davanti al tribunale, dove nelle materie sanitarie viene normalmente nominato un consulente medico. Non sempre i due percorsi sono alternativi, e scegliere quello sbagliato — o lasciar passare i termini — può precludere la tutela. Per questo la valutazione iniziale del provvedimento è il passaggio più importante.",
      },
      { type: "h2", text: "Tempi e documenti utili" },
      {
        type: "list",
        items: [
          "Il provvedimento INPS ricevuto, completo di busta o data di notifica",
          "Estratto conto contributivo aggiornato",
          "Documentazione sanitaria, se la questione riguarda invalidità o inabilità",
          "Buste paga e documentazione di lavoro, per le questioni contributive",
          "Eventuali precedenti domande e verbali",
        ],
      },
      {
        type: "p",
        text: "Se hai ricevuto un provvedimento INPS che ritieni ingiusto, puoi richiedere un appuntamento presso il mio studio a Palermo: esamineremo insieme l'atto, i termini disponibili e le concrete possibilità di tutela, con piena chiarezza su costi e prospettive.",
      },
    ],
  },
  {
    slug: "inps-restituzione-somme-cosa-fare",
    title: "L'INPS chiede la restituzione di somme: cosa fare?",
    category: "Indebiti INPS",
    date: "2026-07-02",
    dateLabel: "2 luglio 2026",
    readingTime: "4 min",
    excerpt:
      "Hai ricevuto una richiesta di restituzione dall'INPS? Non significa dover pagare senza verifiche: ecco come leggere il provvedimento e quali controlli fare.",
    metaDescription:
      "L'INPS chiede indietro delle somme? Cosa fare quando arriva una richiesta di restituzione: verifiche da effettuare, termini e possibilità di contestazione.",
    blocks: [
      {
        type: "p",
        text: "Ricevere una lettera con cui l'INPS chiede la restituzione di somme ritenute indebitamente percepite è un evento che preoccupa, soprattutto quando gli importi sono rilevanti. La prima cosa da sapere è che una richiesta di restituzione non equivale automaticamente a un debito certo: prima di assumere decisioni, il provvedimento va letto e verificato.",
      },
      { type: "h2", text: "Da dove può nascere un indebito" },
      {
        type: "p",
        text: "Le richieste di restituzione possono riguardare pensioni, prestazioni previdenziali, invalidità civile e prestazioni assistenziali. Tra le cause più frequenti vi sono ricalcoli dell'assegno, il superamento dei limiti reddituali richiesti per la prestazione, revoche successive a verifiche e, in alcuni casi, errori nella lavorazione della pratica.",
      },
      { type: "h2", text: "Cosa verificare subito" },
      {
        type: "list",
        items: [
          "Le ragioni indicate dall'INPS a fondamento della richiesta",
          "Il periodo interessato e l'importo di ciascuna annualità",
          "Le date di ricevimento dei provvedimenti, utili per calcolare i termini",
          "La correttezza dei calcoli e dei dati reddituali utilizzati",
          "L'eventuale prescrizione di una o più annualità richieste",
        ],
      },
      {
        type: "p",
        text: "Questi elementi consentono di comprendere se la richiesta è legittima, se lo è solo in parte o se esistono margini di contestazione. In alcuni casi l'indebito può essere oggetto di annullamento o riduzione; in altri, quando la somma è dovuta, è comunque possibile valutare una rateizzazione.",
      },
      {
        type: "link",
        href: "/indebiti-inps-palermo",
        label: "Pagina dedicata",
        text: "Indebiti INPS e richieste di restituzione",
      },
      {
        type: "p",
        text: "Se hai ricevuto una richiesta di restituzione a Palermo o in provincia, puoi prenotare un appuntamento presso il mio studio: esamineremo il provvedimento, i termini disponibili e le concrete possibilità di tutela.",
      },
    ],
  },
  {
    slug: "indebito-pensionistico-inps-quando-contestato",
    title: "Indebito pensionistico INPS: quando può essere contestato",
    category: "Indebiti INPS",
    date: "2026-07-09",
    dateLabel: "9 luglio 2026",
    readingTime: "4 min",
    excerpt:
      "L'INPS chiede indietro la pensione o parte di essa? Non sempre la richiesta è corretta: errori di calcolo, prescrizione e difetti di comunicazione possono rendere l'indebito contestabile.",
    metaDescription:
      "Indebito pensionistico INPS: quando la richiesta di restituzione della pensione può essere contestata. Errori di calcolo, prescrizione e verifiche utili.",
    blocks: [
      {
        type: "p",
        text: "L'indebito pensionistico si verifica quando l'INPS ritiene di aver erogato una pensione, o una parte di essa, senza che ne ricorressero i presupposti, e ne chiede la restituzione. Per il pensionato la richiesta può riguardare importi accumulati in anni di erogazione: comprendere se e come sia possibile contestarla diventa essenziale.",
      },
      { type: "h2", text: "Come nasce un indebito pensionistico" },
      {
        type: "p",
        text: "Le ipotesi più comuni riguardano il ricalcolo dell'assegno, il superamento dei limiti di reddito previsti per determinate prestazioni o maggiorazioni, la sopravvenuta mancanza di un requisito e le revoche successive a controlli. Non di rado la lavorazione presenta errori: dati reddituali non corretti, annualità già rettificate o periodi conteggiati due volte.",
      },
      { type: "h2", text: "Ipotesi in cui la richiesta può essere contestabile" },
      {
        type: "list",
        items: [
          "Errori di calcolo o nei dati utilizzati dall'istituto",
          "Annualità coperte da prescrizione, che non possono più essere richieste",
          "Comunicazioni carenti, che non spiegano adeguatamente le ragioni dell'addebito",
          "Valutazione non corretta della situazione reddituale del pensionato",
          "Periodi già oggetto di rettifica o conteggiati in modo duplicato",
        ],
      },
      { type: "h2", text: "La valutazione del singolo caso" },
      {
        type: "p",
        text: "Non esiste una risposta valida per tutti: la possibilità di contestare un indebito pensionistico dipende dai documenti, dalle date e dalla normativa applicabile al caso concreto. L'esame del provvedimento e dell'estratto conto permette di verificare se la richiesta di restituzione è legittima e, in caso contrario, di individuare lo strumento di tutela corretto entro i termini.",
      },
      {
        type: "link",
        href: "/indebiti-inps-palermo",
        label: "Pagina dedicata",
        text: "Indebiti INPS e richieste di restituzione",
      },
      {
        type: "p",
        text: "Se l'INPS ti ha chiesto la restituzione di somme legate alla pensione, puoi richiedere una valutazione presso il mio studio a Palermo: verificheremo insieme la legittimità della richiesta e le strade percorribili.",
      },
    ],
  },
  {
    slug: "indebito-assistenziale-richiesta-restituzione-inps",
    title: "Indebito assistenziale e richiesta di restituzione dell'INPS",
    category: "Indebiti INPS",
    date: "2026-07-14",
    dateLabel: "14 luglio 2026",
    readingTime: "4 min",
    excerpt:
      "Le prestazioni assistenziali, come quelle legate all'invalidità civile, dipendono spesso dal reddito: per questo sono tra le più esposte a verifiche e richieste di restituzione.",
    metaDescription:
      "Indebito assistenziale INPS: richieste di restituzione su invalidità civile e prestazioni legate al reddito. Cosa verificare e come tutelarsi.",
    blocks: [
      {
        type: "p",
        text: "Le prestazioni assistenziali — dall'assegno mensile di invalidità civile ad altre prestazioni legate allo stato di bisogno — sono concesse a precise condizioni, spesso reddituali. Quando l'INPS ritiene che le condizioni non fossero soddisfatte, può richiedere la restituzione delle somme percepite: si parla in questi casi di indebito assistenziale.",
      },
      { type: "h2", text: "Perché queste prestazioni sono spesso oggetto di verifica" },
      {
        type: "p",
        text: "I limiti reddituali cambiano nel tempo e la situazione economica del beneficiario può variare di anno in anno. I controlli, anche a distanza di anni, possono portare a richieste di restituzione che riguardano periodi lunghi. In altri casi la richiesta deriva dalla revisione dello stato sanitario o da errori nella ricostruzione del reddito familiare.",
      },
      { type: "h2", text: "Cosa fare se ricevi la richiesta" },
      {
        type: "list",
        items: [
          "Conserva il provvedimento e la prova della data di ricevimento",
          "Ricostruisci i redditi degli anni interessati, tuoi e del nucleo familiare",
          "Verifica che i limiti reddituali applicati siano quelli corretti per ciascun anno",
          "Controlla se alcune annualità sono coperte da prescrizione",
          "Fai valutare la documentazione sanitaria, se la richiesta deriva da una revisione",
        ],
      },
      { type: "h2", text: "Rateizzazione e tutela" },
      {
        type: "p",
        text: "Quando la verifica conferma il debito, è spesso possibile chiedere la rateizzazione; quando invece emergono errori o annualità prescritte, si può valutare la contestazione in via amministrativa o giudiziaria. Anche la riduzione parziale dell'importo richiesto può avere un impatto concreto rilevante.",
      },
      {
        type: "link",
        href: "/indebiti-inps-palermo",
        label: "Pagina dedicata",
        text: "Indebiti INPS e richieste di restituzione",
      },
      {
        type: "p",
        text: "Per una valutazione della tua situazione puoi prenotare un appuntamento presso lo studio a Palermo: esamineremo la richiesta e le possibili forme di tutela.",
      },
    ],
  },
  {
    slug: "richiesta-restituzione-inps-quando-avvocato",
    title: "Hai ricevuto una richiesta di restituzione dall'INPS? Quando rivolgersi a un avvocato",
    category: "Indebiti INPS",
    date: "2026-07-16",
    dateLabel: "16 luglio 2026",
    readingTime: "3 min",
    excerpt:
      "Non sempre serve un avvocato, ma in presenza di alcuni segnali la valutazione professionale può evitare pagamenti non dovuti o la perdita dei termini di ricorso.",
    metaDescription:
      "Quando rivolgersi a un avvocato per una richiesta di restituzione INPS: i segnali da non sottovalutare, i termini e cosa può fare il professionista.",
    blocks: [
      {
        type: "p",
        text: "Di fronte a una richiesta di restituzione dell'INPS molte persone scelgono una delle due strade estreme: pagare subito per chiudere la questione, oppure ignorare la comunicazione sperando che si risolva da sé. Entrambe possono rivelarsi errori costosi. Esiste una terza via: verificare.",
      },
      { type: "h2", text: "I segnali che rendono opportuna una valutazione professionale" },
      {
        type: "list",
        items: [
          "L'importo richiesto è elevato o copre molti anni di erogazione",
          "Le ragioni dell'addebito non sono chiare o non ti risultano corrette",
          "La richiesta riguarda periodi molto risalenti, potenzialmente prescritti",
          "L'INPS ha già avviato trattenute sulla pensione o minaccia il recupero",
          "Hai già presentato documenti che l'istituto non sembra aver considerato",
        ],
      },
      { type: "h2", text: "Cosa può fare l'avvocato" },
      {
        type: "p",
        text: "Il lavoro inizia dall'esame del provvedimento e dei documenti: origine dell'indebito, periodo, calcoli, comunicazioni e termini. Sulla base di questa analisi ti spiego con chiarezza se la richiesta appare legittima, se è contestabile in tutto o in parte e quale strumento utilizzare — ricorso amministrativo o giudiziario — con una stima realistica di tempi, costi e possibilità.",
      },
      { type: "h2", text: "I tempi contano" },
      {
        type: "p",
        text: "I termini per contestare una richiesta di restituzione decorrono dalla ricezione del provvedimento e, una volta scaduti, l'addebito diventa definitivo. Portare i documenti a una valutazione tempestiva non ti impegna ad alcuna azione: ti consente semplicemente di decidere con consapevolezza.",
      },
      {
        type: "link",
        href: "/indebiti-inps-palermo",
        label: "Pagina dedicata",
        text: "Indebiti INPS e richieste di restituzione",
      },
      {
        type: "p",
        text: "Il mio studio è a Palermo, in Via Salvatore Meccio 22: puoi prenotare un appuntamento o richiedere di essere ricontattato dalla segreteria tramite il modulo contatti.",
      },
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
